import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SaveContractService {
  private saveSubject = new Subject<void>();
  private newClientSubject = new Subject<void>();
  private contractstatus = new Subject<void>();
  private contractReload = new Subject<void>();

  save$ = this.saveSubject.asObservable();
  newClient$ = this.newClientSubject.asObservable();
  contractStatus$ = this.contractstatus.asObservable();
  contractReload$ = this.contractReload.asObservable();

  triggerSave() {
    this.saveSubject.next();
  }

  triggerNewClient() {
    this.newClientSubject.next();
  }

  triggerContractStatusUpdate() {
    this.contractstatus.next();
  }

  triggerContractReload() {
    this.contractReload.next();
  }
}